export default __webpack_public_path__ + "static/media/logo.a622ee4e.svg";